import { MatPaginator } from '@angular/material/paginator';
import { select, Store } from '@ngrx/store';
import { debounceTime } from 'rxjs/operators';

import { AppState } from '../../reducers';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { Note } from '../_models/note.model';
import {
  selectNotePage,
  selectNotePageLoading,
  selectNoteShowInitWaitingMessage,
} from '../_selectors/note.selector';

export class NoteDataSource extends BaseDataSource {
  private _notes: Note[];

  constructor(private store: Store<AppState>, private paginator: MatPaginator) {
    super();

    this.loading$ = this.store.select(selectNotePageLoading);
    this.isPreloadTextViewed$ = this.store.select(selectNoteShowInitWaitingMessage);

    this.store
      .pipe(select(selectNotePage), debounceTime(500))
      .subscribe((res: QueryResultsModel) => {
        this._notes = res.items;

        this.entitySubject.next(res.items.slice(0, this.paginator.pageSize));
        this.paginatorTotalSubject.next(res.totalCount);
      });
  }

  get notes() {
    return this._notes;
  }
}
